import React, { useCallback, useEffect, useRef, useState } from "react";
import { getDateInFormat, getFinancialYear, getFinancialYears, } from "@domains/utils/reportDates";
import moment from "moment";
import "@frameworks/web/stylesheets/components/Reports/DpInterest/DpInterest.scss";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import EdModal from "@frameworks/web/components/generic/edModal";
import { previousDay } from "@domains/utils/reportDates";
import DownloadReportPopupDesk from "@frameworks/web/components/generic/DownloadReports/DownloadReportPopupDesk";
import PopupLoader from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoader";
import SuccessPopup from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import PopupFail from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import { EquityDropdown, } from "@frameworks/web/components/generic/equitydropdown/equitydropdown";
import Drawer from "react-bottom-drawer";
import CalendarPopupMob from "@frameworks/web/components/generic/Calendar/CalendarPopupMob";
import CalendarPopupDesk from "@frameworks/web/components/generic/Calendar/CalendarPopupDesk";
import DpInterestAccordion from "./DpInterestAccordion";
import dpInterestDi from "@frameworks/web/components/Reports/DpInterest/di/servicelocator";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import CommonDownloadReport from "../CommonComponent/CommonDownloadReport";
import DpInterestMobileTable, { threePaths } from "./DpInterestMobileTable";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import taxDownloadDi from "@frameworks/web/components/Reports/TaxReports/di/servicelocator";
import { useDispatch, useSelector } from "react-redux";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import mainDI, { accountDetails } from "@frameworks/web/di/index";
import SmcasePopupFailMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFailMob";
import SmcasePopupSuccessMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccessMob";
import SmcasePopupLoaderMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoaderMob";
import FamilyTaggingMain from "../FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
import { useParams } from "react-router-dom";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { LoginSource } from "@domains/utils/emtReportCallback";
const dpInterestDropdown = [
    { title: "Normal", value: "NORMAL" },
    { title: "MTF", value: "MTF" },
    { title: "FNO", value: "FNO" },
];
const DpInterestMain = () => {
    const device = DeviceContext();
    const dispatch = useDispatch();
    const { loginSource } = useParams();
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const initStartDate = useCallback(() => {
        if (new Date(finYear, 3, 1) > new Date())
            return new Date(finYear - 1, 3, 1);
        return new Date(finYear, 3, 1);
    }, []);
    const emailStatus = useSelector((state) => { var _a; return (_a = state.taxReport) === null || _a === void 0 ? void 0 : _a.emailStatus; });
    const downloadStatus = useSelector((state) => { var _a; return (_a = state.taxReport) === null || _a === void 0 ? void 0 : _a.downloadStatus; });
    const [finYear, setFinYear] = React.useState(getFinancialYear(new Date()));
    const [nextFinYear, setNextFinYear] = React.useState(finYear + 1);
    const [startDate, setStartDate] = React.useState(initStartDate());
    const [endDate, setEndDate] = React.useState(previousDay);
    const [downloadstartDate, setDownloadStartDate] = React.useState(startDate);
    const [downloadendDate, setDownloadEndDate] = React.useState(endDate);
    const [openCalendar, setOpenCalendar] = React.useState(false);
    const [downloadLoader, setDownloadLoader] = useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const [operation, setOperation] = React.useState();
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const CalederRef = React.useRef(null);
    const equityDropdownRef = useRef(null);
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const [downloadPopUp, setDownloadPopUp] = useState(false);
    const [dpType, setDpType] = React.useState(dpInterestDropdown[0].value);
    const [dpInterestDropdownList, setDpInterestDropdownList] = React.useState(dpInterestDropdown);
    const [selectedDpInterestDropdown, setSelectedDpInterestDropdown] = useState(dpInterestDropdownList[0]);
    const [showAllEmails, setShowAllEmails] = React.useState(false);
    const { reducersData: dpiCharges, commonData: chargesCommonData } = useSelector((state) => state.DpInterest.dpiCharges);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginSource !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const toggleShowAllEmails = () => {
        setShowAllEmails(!showAllEmails);
    };
    const closeDrawerLoader = React.useCallback(() => setDownloadLoader(false), []);
    const openDrawerDownloadS = React.useCallback(() => setDownloadSuccess(true), []);
    const closeDrawerDownloadS = React.useCallback(() => setDownloadSuccess(false), []);
    const disabledDownload = () => {
        return (chargesCommonData.errorData.isOpen ||
            chargesCommonData.loader ||
            chargesCommonData.message.icon ===
                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.DPBILL].icon);
    };
    const closeDrawerFail = React.useCallback(() => setDownloadFail(false), []);
    const financialYears = getFinancialYears(startDate, endDate);
    const openDrawerFail = React.useCallback(() => setDownloadFail(true), []);
    const downloadEmailDpInterest = (email, download) => {
        setDownloadPopUp(false);
        let emailPayload = null, downloadPayload = null;
        if (email) {
            emailPayload = {
                fromDate: moment(startDate).format("yyyy-MM-DD"),
                toDate: moment(endDate).format("yyyy-MM-DD"),
                reportType: email.reportType,
                emailIds: email.emailIds,
                reportName: ReportName.DP,
                dpType: dpType,
                accodes: accCode,
            };
            emailPayload.urlParts = "/cash";
            emailPayload.usetaxDPURL = true;
        }
        if (download) {
            downloadPayload = {
                reportName: ReportName.DP,
                fromDate: download.fromDate,
                toDate: download.toDate,
                reportType: download.reportType,
                dpType: dpType,
                accodes: accCode,
            };
            downloadPayload.urlParts = "/cash";
            downloadPayload.usetaxDPURL = true;
        }
        taxDownloadDi.taxReport.downloadAndSendReportTax(emailPayload, downloadPayload);
    };
    const DownloadSubmitButtonText = () => {
        if ((downloadCheck && emailCheck) || (!downloadCheck && !emailCheck))
            return React.createElement(React.Fragment, null, "Download and Send Report");
        if (downloadCheck)
            return React.createElement(React.Fragment, null, "Download Report");
        if (emailCheck)
            return React.createElement(React.Fragment, null, "Send Report");
    };
    const modalTitleDwnldEmail = () => {
        if (downloadCheck && emailCheck)
            return "Download and Send Delayed Payment Interest";
        if (downloadCheck)
            return " Download Delayed Payment Interest";
        if (emailCheck)
            return "Send Delayed Payment Interest";
    };
    const loaderMessage = () => {
        if (downloadCheck && emailCheck)
            return "Download & Share";
        if (downloadCheck)
            return "download";
        if (emailCheck)
            return "share";
    };
    const FailureMessage = () => {
        if (downloadCheck && emailCheck)
            return "to download and share";
        if (downloadCheck)
            return "to download";
        if (emailCheck)
            return "to share";
    };
    const downloadSuccessNode = () => {
        const emailList = taxDownloadDi.taxReport.emailList;
        if (downloadCheck && emailCheck) {
            return (React.createElement("div", { className: "DMSans_16_500  text-center txt_primaryGrey mgt-5 lh-140" },
                "Your Delayed Payment Interest is successfully Downloaded and also Shared with",
                device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 ? (emailList.join()) : (React.createElement(React.Fragment, null,
                    emailList.slice(0, 3).join(),
                    React.createElement(GenericTooltip, { placement: "right", button: React.createElement("span", null,
                            "and",
                            " ",
                            React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline" },
                                emailList.length - 3,
                                " More",
                                " ",
                                emailList.length - 3 === 1 ? "email" : "emails")), toolTipText: React.createElement(React.Fragment, null, emailList.slice(3).map((x) => (React.createElement("div", null, x)))), triggerType: "hover", toolTipClassName: "download-email-tooltip", externalClassName: "remove-btn-props" }))))) : (React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 || showAllEmails ? (emailList.map((item, index) => (React.createElement("div", { key: index }, index < emailList.length - 1 ? `${item}, ` : item)))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", null, emailList.slice(0, 3).join(", ")),
                    React.createElement("div", null,
                        "and",
                        " ",
                        React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline", onClick: toggleShowAllEmails },
                            emailList.length - 3,
                            " More",
                            " ",
                            emailList.length - 3 === 1 ? "email" : "emails"))))))));
        }
        if (downloadCheck)
            return (React.createElement("div", { className: "DMSans_16_500  text-center txt_primaryGrey" },
                "Your Delayed Payment Interest is ",
                React.createElement("br", null),
                " successfully downloaded"));
        if (emailCheck)
            return (React.createElement("div", { className: "DMSans_16_500 text-center txt_primaryGrey" },
                "Your Delayed Payment Interest is successfully shared with",
                device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 ? (emailList.join()) : (React.createElement(React.Fragment, null,
                    emailList.slice(0, 3).join(),
                    React.createElement(GenericTooltip, { placement: "right", button: React.createElement("span", { className: "" },
                            "and",
                            " ",
                            React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline" },
                                emailList.length - 3,
                                " More",
                                " ",
                                emailList.length - 3 === 1 ? "email" : "emails")), toolTipText: React.createElement(React.Fragment, null, emailList.slice(3).map((x) => (React.createElement("div", null, x)))), triggerType: "hover", toolTipClassName: "download-email-tooltip", externalClassName: "remove-btn-props" }))))) : (React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 || showAllEmails ? (emailList.map((item, index) => (React.createElement("div", { key: index }, index < emailList.length - 1 ? `${item}, ` : item)))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", null, emailList.slice(0, 3).join(", ")),
                    React.createElement("div", null,
                        "and",
                        " ",
                        React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline", onClick: toggleShowAllEmails },
                            emailList.length - 3,
                            " More",
                            " ",
                            emailList.length - 3 === 1 ? "email" : "emails"))))))));
    };
    React.useEffect(() => {
        if (endDate)
            setDownloadEndDate(endDate);
        if (startDate)
            setDownloadStartDate(startDate);
    }, [endDate, startDate]);
    React.useEffect(() => {
        if (device === null || device === void 0 ? void 0 : device.isDesktop)
            mainDI.header.RemoveHeaderData(true);
        else
            mainDI.header.RemoveHeaderData(false);
        dispatch(mainDI.footer.updateShowMob_Menu(false));
    }, [device]);
    React.useEffect(() => {
        const handleScroll = () => {
            const scrollLimit = 150;
            if (openCalendar) {
                const scrollY = window.scrollY || document.documentElement.scrollTop;
                if (scrollY > scrollLimit) {
                    setOpenCalendar(false);
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [openCalendar]);
    React.useEffect(() => {
        if ((emailStatus.isOpen !== null || downloadStatus.isOpen !== null) &&
            downloadLoader &&
            (emailCheck || downloadCheck)) {
            closeDrawerLoader();
            if ((emailCheck && emailStatus.isOpen === true) ||
                (downloadCheck && downloadStatus.isOpen === true)) {
                openDrawerDownloadS();
            }
            else {
                openDrawerFail();
            }
        }
    }, [emailStatus.isOpen, downloadStatus.isOpen]);
    const [openFamilyDrop, setOpenFamilyDrop] = useState(false);
    const [accCode, setAccCode] = useState("");
    const familyTagDPApply = (accountCodes) => {
        let payload = {
            fromDate: getDateInFormat(startDate, "YYYY-MM-DD"),
            toDate: getDateInFormat(endDate, "YYYY-MM-DD"),
            dpType: dpType,
            accountCode: accountCodes,
        };
        dpInterestDi.dpInterest.getDpInterestCharges(payload);
        setOpenFamilyDrop(false);
    };
    const getAccountCode = () => {
        accountDetails.getAccountCode().then((x) => {
            setAccCode(x);
        });
    };
    React.useEffect(() => {
        if (accCode)
            familyTagDPApply(accCode);
    }, [accCode, startDate, endDate, dpType]);
    useEffect(() => {
        getAccountCode();
    }, []);
    React.useEffect(() => {
        setShowAllEmails(false);
    }, [taxDownloadDi.taxReport.emailList]);
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (CalederRef.current && !CalederRef.current.contains(event.target)) {
                setOpenCalendar(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [CalederRef]);
    return (React.createElement("div", { className: `new-reports-modalBackdrop common-reports-download-mail ${downloadLoader || downloadSuccess || downloadFail
            ? "modal-opacity-0"
            : ""}` },
        React.createElement("div", { className: "dpbillsInterest-main-block" },
            React.createElement("div", { className: `pdt-30 txt-midnight-blue ${(device === null || device === void 0 ? void 0 : device.isDesktop)
                    ? "displayFlex mgb-30 justify-content-between align-items-center"
                    : "flexJustifySpaceBetween mgb-20"}` },
                React.createElement("span", { className: (device === null || device === void 0 ? void 0 : device.isDesktop) ? "DMSan_28_400 mgr-5" : "DMSansMedium_20_500" },
                    React.createElement("span", { className: (device === null || device === void 0 ? void 0 : device.isDesktop)
                            ? "DMSan_28_700 mgr-5"
                            : "DMSansBold_20_700 mgr-5" }, "Delayed Payments"),
                    "Interest"),
                React.createElement("div", { className: "mk-card-topright d-flex align-items-center common-info-icon" }),
                (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(FamilyTaggingMain, { handleApply: (accountCode) => {
                        setAccCode(accountCode);
                    }, setOpenFamilyDrop: setOpenFamilyDrop, openFamilyDrop: openFamilyDrop }))),
            (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("div", { className: "flexJustifySpaceBetween" },
                        React.createElement("div", { className: "calender-sub-section common-calender-subsection-backColor", ref: CalederRef },
                            React.createElement("div", { className: "calendar_date" },
                                React.createElement("div", { className: "displayFlex" },
                                    React.createElement("div", { className: "fin_year" }, financialYears.label),
                                    React.createElement("div", { className: "datefullClass" }, `(${moment(startDate).format("D-MMM-YY")} to ${moment(endDate).format("D-MMM-YY")})`),
                                    React.createElement("div", { className: "calendar_change displayFlex" },
                                        React.createElement("i", { className: "edel-icon-coloured-calendar pe-2" }, Array(7)
                                            .fill("")
                                            .map((i, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` })))),
                                        React.createElement("div", { onClick: () => setOpenCalendar(!openCalendar) }, "Change")))),
                            React.createElement("div", { className: "tax-calender calendar-icon-set midnightblue-theme" },
                                React.createElement(CalendarPopupDesk, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, startDate: startDate, endDate: endDate, finYear: finYear, setStartDate: setStartDate, setEndDate: setEndDate, setFinYear: setFinYear, customTime: true, setNextFinYear: setNextFinYear }))),
                        React.createElement("div", { className: "d-flex gap-10" },
                            React.createElement("div", { className: "displayFlex dropdown-block", ref: equityDropdownRef },
                                React.createElement(EquityDropdown, { itemlist: dpInterestDropdownList.filter((x) => x.value !== selectedDpInterestDropdown.value), defaultVal: true, selectedDefaultVal: selectedDpInterestDropdown, selectedValue: (selectedItem) => {
                                        setDpType(selectedItem.value);
                                        setSelectedDpInterestDropdown(selectedItem);
                                        let updatedList = dpInterestDropdown.filter((item) => item.value !== selectedItem.value);
                                        setDpInterestDropdownList(updatedList);
                                    }, externalClassname: "dpbills-dropdown-new", bigIcon: true })),
                            React.createElement("div", { className: "common-download", onClick: () => {
                                    if (!disabledDownload())
                                        setDownloadPopUp(true);
                                } },
                                React.createElement("button", { className: `download-btn ` },
                                    React.createElement("i", { className: "edel-icon-download-coloured" },
                                        React.createElement("span", { className: "path1" }),
                                        React.createElement("span", { className: "path2" })),
                                    "Download"))))),
                React.createElement("div", null,
                    React.createElement(DpInterestAccordion, { dpType: dpType })))) : (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("div", { className: ` gap-10 displayFlex` },
                        React.createElement("div", { className: "calendar_date d-space-between" },
                            React.createElement("div", null,
                                React.createElement("div", { className: "RobotoR_20_700 txt_blackOne1" },
                                    React.createElement("span", { className: "fin_year px-1" }, financialYears.label),
                                    React.createElement("span", { className: `date ${(device === null || device === void 0 ? void 0 : device.isDesktop)
                                            ? "RobotoR_20_400"
                                            : "RobotoR_14_400  txt_primaryGrey"}` }, `(${moment(startDate).format("D-MMM-YY")} to ${moment(endDate).format("D-MMM-YY")})`)))),
                        React.createElement("div", null,
                            React.createElement("div", { className: "calendar_change" },
                                React.createElement("i", { className: "edel-icon-coloured-calendar pe-2" }, Array(7)
                                    .fill("")
                                    .map((i, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` })))),
                                React.createElement("div", { className: "DMSanN_14_400 txt-midnight-blue", onClick: () => setOpenCalendar(!openCalendar) }, "Change")))),
                    React.createElement("div", { className: "drawer_year_container common-download-newtheme calendar-icon-set midnightblue-theme" },
                        React.createElement(CalendarPopupMob, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, startDate: startDate, endDate: endDate, finYear: finYear, setStartDate: setStartDate, setEndDate: setEndDate, setFinYear: setFinYear, customTime: true, setNextFinYear: setNextFinYear, customTimeText: "Custom Date Range" }))),
                !(device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", { className: "pt-10" },
                    React.createElement(FamilyTaggingMain, { handleApply: (accountCode) => {
                            setAccCode(accountCode);
                        }, setOpenFamilyDrop: setOpenFamilyDrop, openFamilyDrop: openFamilyDrop, oldTheme: true }))),
                React.createElement("div", { className: "flexJustifySpaceBetween pdt-20" },
                    React.createElement(EquityDropdown, { itemlist: dpInterestDropdownList.filter((x) => x.value !== selectedDpInterestDropdown.value), defaultVal: true, selectedDefaultVal: selectedDpInterestDropdown, selectedValue: (selectedItem) => {
                            setDpType(selectedItem.value);
                            setSelectedDpInterestDropdown(selectedItem);
                            let updatedList = dpInterestDropdown.filter((item) => item.value !== selectedItem.value);
                            setDpInterestDropdownList(updatedList);
                        }, externalClassname: "dpbills-dropdown-new", bigIcon: true }),
                    React.createElement("div", { className: "d-flex gap-10" },
                        React.createElement("div", { className: "common-download", onClick: () => {
                                if (!disabledDownload())
                                    setDownloadPopUp(true);
                            } },
                            React.createElement("button", { className: `download-btn ` },
                                React.createElement("i", { className: "edel-icon-download-coloured" },
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" })))))),
                React.createElement(DpInterestMobileTable, { dpType: dpType })))),
        device && device.isDesktop ? (React.createElement(React.Fragment, null,
            React.createElement(EdModal, { show: downloadPopUp, setShow: setDownloadPopUp, size: "modal-md modal-dialog-centered", iconClass: "gap-8 icon-new-20", icon: "edel-icon-download-color-new", paths: threePaths, modalTitle: "commonnew-modal-download-popup modalDPTitle commonmodal gray-modal report-common-modal", title: "Download Delayed Payment Interest", showFooter: false },
                React.createElement("div", { className: "downloadHoldingDesk taxreport" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12 col-lg-12 downloadHoldingDesk-form common-reports-download-mail" },
                            React.createElement(DownloadReportPopupDesk, { startDate: downloadstartDate, endDate: downloadendDate, PDF_or_Excel: ReportType.PDF, setEndDate: setDownloadEndDate, setStartDate: setDownloadStartDate, openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, showLoader: downloadLoader, setShowLoader: setDownloadLoader, setDownloadSuccess: setDownloadSuccess, setDownloadFail: setDownloadFail, setOperation: setOperation, showdate: false, withEndDate: true, reportType: undefined, submit: downloadEmailDpInterest, resetFields: downloadPopUp, setEmailCheck: setEmailCheck, setDownloadCheck: setDownloadCheck, selectedDpType: dpType, submitBtnText: DownloadSubmitButtonText() }))))),
            downloadLoader && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupLoader, { isDownload: downloadCheck && emailCheck, message: `Your Delayed Payment Interest Report is getting prepared to ${loaderMessage()}`, Title: modalTitleDwnldEmail(), reportText: true, isDownloadIcon: true, goBack: () => setDownloadPopUp(false) })))),
            downloadSuccess && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(SuccessPopup, { setDownloadSuccess: setDownloadSuccess, Title: modalTitleDwnldEmail(), reportText: true, operation: operation, goBackText: true, pageName: ReportName.DPINTEREST, sendBack: true, messageReactNode: downloadSuccessNode(), isDownloadIcon: true, message: "Your Delayed Payment Interest Report is successfully downloaded", goBack: () => setDownloadPopUp(false) })))),
            downloadFail && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupFail, { setDownloadFail: setDownloadFail, Title: modalTitleDwnldEmail(), reportText: true, operation: operation, goBackText: true, pageName: ReportName.DPINTEREST, sendBack: true, isDownloadIcon: true, message: `<span class='DMSans_16_500'>We ran in to some technical difficulties, <br/> please try ${FailureMessage()} the report again!</span>`, goBack: () => setDownloadPopUp(false) })))))) : (React.createElement("div", { className: `common-mob-smallcase-popup-download ${!isClientLogin && "not-client-login"} mb-genericSidebar` },
            React.createElement(GenericDrawer, { show: downloadPopUp, setShow: setDownloadPopUp, parentClass: "z-index-high commonnew-download-report-drawer", headerComp: React.createElement("span", { className: "DMSanN_16_400 txt-midnight-blue pdl-20" }, "Download Report"), bodyComp: React.createElement("div", { className: "common-reports-download-mail" },
                    React.createElement(CommonDownloadReport, { startDate: downloadstartDate, endDate: downloadendDate, setEndDate: setDownloadEndDate, setStartDate: setDownloadStartDate, withEndDate: true, setDownloadSuccess: setDownloadSuccess, setShowLoader: setDownloadLoader, setDownloadFail: setDownloadFail, showLoader: downloadLoader, downloadSuccess: downloadSuccess, downloadFail: downloadFail, setOperation: setOperation, operation: operation, setEmailCheck: setEmailCheck, setDownloadCheck: setDownloadCheck, submitDownload: downloadEmailDpInterest, messageReactNode: downloadSuccessNode(), goBack: () => setDownloadPopUp(false), PDF_or_Excel: ReportType.PDF })) }),
            React.createElement(Drawer, { isVisible: downloadLoader || downloadSuccess || downloadFail, onClose: () => {
                    closeDrawerLoader();
                    closeDrawerDownloadS();
                    closeDrawerFail();
                }, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper z-index-high" },
                downloadLoader && (React.createElement(SmcasePopupLoaderMob, { Title: modalTitleDwnldEmail(), closeDrawer: closeDrawerLoader, message: `Your Delayed Payment Interest Report is getting prepared to ${loaderMessage()}` })),
                downloadSuccess && (React.createElement(SmcasePopupSuccessMob, { messageReactNode: downloadSuccessNode(), Title: modalTitleDwnldEmail(), closeDrawer: closeDrawerDownloadS, operation: operation, pageName: ReportName.DPINTEREST, isDownloadIcon: true, goBackText: true, sendBack: true, goBack: () => setDownloadPopUp(false) })),
                downloadFail && (React.createElement(SmcasePopupFailMob, { closeDrawer: closeDrawerFail, operation: operation, pageName: ReportName.DPINTEREST, goBackText: true, goBack: () => setDownloadPopUp(false), sendBack: true, message: `<span class='DMSans_16_500'>We ran into some technical  difficulties,<br> please try ${FailureMessage()} the report again!</span>` })))))));
};
export default DpInterestMain;
